import * as AssetMetadataHorizontalModule from './AssetMetadataHorizontal';
export { default as AssetMetadataVertical } from './AssetMetadataVertical';
export const AssetMetadataHorizontal = AssetMetadataHorizontalModule.default;
export default AssetMetadataHorizontal;
